import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const StitchingEntry = createAsyncThunk('StitchingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertStitchingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const UpdateStitchingEntry = createAsyncThunk('UpdateStitchingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateStitchingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const StitchingReturns = createAsyncThunk('StitchingReturns', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertStitchingReturn`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchReturnMemoNo = createAsyncThunk('fetchReturnMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCuttingReturnMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchFusionMemoStitching = createAsyncThunk('fetchFusionMemoStitching', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getFusioningMemoForStitching`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchEmplist = createAsyncThunk('fetchStitchEmplist', async (id) => {
    try {
        const endpoint = id ? `getStitchEmplist&empId=${id}` : 'getStitchEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchMemoNo = createAsyncThunk('fetchStitchMemoNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStitchMemoNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchStitchingReg = createAsyncThunk('fetchStitchingReg', async (id) => {
    try {
        const endpoint = id ? `getStitchingRegister&stId=${id}` : 'getStitchingRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchingReg2 = createAsyncThunk('fetchStitchingReg2', async (id) => {
    try {
        // const endpoint = id ? `getStitchingRegister&stId=${id}` : 'getStitchingRegister';
        const response = await axios.get(`${baseUrl}?apicall=getStitchingRegister&stMemo=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchingReturnlist = createAsyncThunk('fetchStitchingReturnlist', async (id) => {
    try {
        const endpoint = id ? `getStitchingReturnlist&sreId=${id}` : 'getStitchingReturnlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchReturnGrpStid = createAsyncThunk('fetchStitchReturnGrpStid', async (id) => {
    try {
        const endpoint = id ? `getStitchingReturnlist&stId=${id}` : 'getStitchingReturnlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchReturnGrpStid2 = createAsyncThunk('fetchStitchReturnGrpStid2', async (id) => {
    try {
        const endpoint = id ? `getStitchingReturnlist&stId=${id}` : 'getStitchingReturnlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchToPackEmp = createAsyncThunk('fetchStitchToPackEmp', async (id) => {
    try {
        const endpoint = id ? `getStitchToPackEmplist&empId=${id}` : 'getStitchToPackEmplist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchContraRegister = createAsyncThunk('fetchStitchContraRegister', async (id) => {
    try {
        const endpoint = id ? `getStitchingContractorReg&stId=${id}` : 'getStitchingContractorReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchContraRegister2 = createAsyncThunk('fetchStitchContraRegister2', async (id) => {
    try {
        // const endpoint = id ? `getStitchingContractorReg&stId=${id}` : 'getStitchingContractorReg';
        const response = await axios.get(`${baseUrl}?apicall=getStitchingContractorReg&stMemo=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchContraReturn = createAsyncThunk('fetchStitchContraReturn', async (id) => {
    try {
        const endpoint = id ? `getStitchContractorReturnlist&sreId=${id}` : 'getStitchContractorReturnlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStitchContReGrp = createAsyncThunk('fetchStitchContReGrp', async (id) => {
    try {
        const endpoint = id ? `getStitchContractorReturnlist&stId=${id}` : 'getStitchContractorReturnlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteStitchEntry = createAsyncThunk('deleteStitchEntry', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteStitching&stId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const StitchApiSlice = createSlice({
    name: 'StitchDatalist',
    initialState: {
        isLoading: false,
        reMemo: null,
        emplist: null,
        stMemo: null,
        stlist: null,
        stReturn: null,
        stRGrp: null,
        stRGrp2: null,
        stpackEmp: null,
        contlist: null,
        contReturn: null,
        contReGrp: null,
        deleteSt: null,
        fmemost: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchReturnMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchReturnMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.reMemo = action.payload;
        });
        builder.addCase(fetchReturnMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchEmplist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchEmplist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.emplist = action.payload;
        });
        builder.addCase(fetchStitchEmplist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchMemoNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchMemoNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stMemo = action.payload;
        });
        builder.addCase(fetchStitchMemoNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchingReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchingReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stlist = action.payload;
        });
        builder.addCase(fetchStitchingReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchingReturnlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchingReturnlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stReturn = action.payload;
        });
        builder.addCase(fetchStitchingReturnlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchReturnGrpStid.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchReturnGrpStid.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stRGrp = action.payload;
        });
        builder.addCase(fetchStitchReturnGrpStid.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });



        builder.addCase(fetchStitchToPackEmp.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchToPackEmp.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stpackEmp = action.payload;
        });
        builder.addCase(fetchStitchToPackEmp.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStitchContraRegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchContraRegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contlist = action.payload;
        });
        builder.addCase(fetchStitchContraRegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStitchContraReturn.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchContraReturn.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contReturn = action.payload;
        });
        builder.addCase(fetchStitchContraReturn.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStitchContReGrp.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchContReGrp.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contReGrp = action.payload;
        });
        builder.addCase(fetchStitchContReGrp.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(deleteStitchEntry.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteStitchEntry.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteSt = action.payload;
        });
        builder.addCase(deleteStitchEntry.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchStitchReturnGrpStid2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchReturnGrpStid2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stRGrp2 = action.payload;
        });
        builder.addCase(fetchStitchReturnGrpStid2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchStitchingReg2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchingReg2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stlist = action.payload;
        });
        builder.addCase(fetchStitchingReg2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStitchContraRegister2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStitchContraRegister2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.contlist = action.payload;
        });
        builder.addCase(fetchStitchContraRegister2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchFusionMemoStitching.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchFusionMemoStitching.fulfilled, (state, action) => {
            state.isLoading = false;
            state.fmemost = action.payload;
        });
        builder.addCase(fetchFusionMemoStitching.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default StitchApiSlice.reducer;
